import React from "react"
import { useRef, useState } from "react"

import Button from "react-bootstrap/lib/Button"
import Overlay from "react-bootstrap/lib/Overlay"
import Tooltip from "react-bootstrap/lib/Tooltip"

// ----------------------------------------------------------------------------

function AddServiceButton(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { enabled, onClick, missingConfigs } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const btnRef = useRef(null)
  const [showWarningTooltip, setShowWarningTooltip] = useState(false)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleButtonClick(event) {
    event.preventDefault()

    if (!enabled) {
      setShowWarningTooltip(true)
    }

    onClick()
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const buttonClassNames = enabled ? "" : "disabled"

  // -------------------------------------

  return (
    <div>
      <Button
        ref={btnRef}
        onClick={handleButtonClick}
        className={`btn btn-primary btn-sm ${buttonClassNames}`}
      >
        {I18n.t("service_ordering.add_to_cart")}
      </Button>

      <Overlay
        rootClose={true}
        target={btnRef.current}
        show={showWarningTooltip}
        onHide={() => setShowWarningTooltip(false)}
        placement="top"
      >
        <Tooltip id="warning-message">
          {I18n.t("service_ordering.must_configure_meal") + ": " + missingConfigs.join(", ")}
        </Tooltip>
      </Overlay>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default AddServiceButton
